export default "__VITE_ASSET__7PeBWpp$__"